import React from "react";
import { Alert, FormControl, TextField } from "@mui/material";
import EditorTexto from "../../EditorTexto";
import SeccionEvento from "./SeccionEvento";

const estiloInput = {
  marginTop: "5px",
  marginBottom: "15px",
  input: { padding: "10px 15px" },
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    "& fieldset": { borderColor: "#d1d1d1", borderWidth: "1px" },
    "&:hover fieldset": { borderColor: "#3659E3", borderWidth: "2px" },
    "&.Mui-focused fieldset": { borderColor: "#3659E3", borderWidth: "2px" },
    transition: "all 0.2s ease-in-out",
  },
};

const NameSection = ({ evento, descripcion, onChange, errores, abierta, onToggle }) => (
  <SeccionEvento
    id="gral"
    titulo="Nombre del evento"
    tituloExpandido="Descripción general del evento"
    descripcion="Introduce el nombre de tu evento para identificarlo y destacarlo de manera clara y atractiva."
    requerido
    tieneError={Boolean(errores.evento || errores.descripcion)}
    abierta={abierta}
    onToggle={onToggle}
  >
    <FormControl fullWidth>
      <p className="subtitulo-seccion-evento-expanded">
        Nombre del evento <span className="text-danger">*</span>
      </p>
      <p className="descrip-seccion-evento-expanded mb-0">
        Escribe un título claro y descriptivo para indicar de qué se trata el evento.
      </p>
      <TextField
        sx={estiloInput}
        type="text"
        name="evento"
        value={evento}
        placeholder="Nombre del evento"
        onChange={(e) => onChange("evento", e.target.value)}
      />
      {errores.evento && (
        <Alert severity="error" sx={{ marginBottom: "15px" }}>
          {errores.evento}
        </Alert>
      )}
    </FormControl>

    <FormControl fullWidth>
      <p className="subtitulo-seccion-evento-expanded">
        Descripción <span className="text-danger">*</span>
      </p>
      <p className="descrip-seccion-evento-expanded">
        Captá la atención con una breve descripción de tu evento. Los asistentes la verán
        en la parte superior de tu página del evento.
      </p>
      <EditorTexto
        value={descripcion}
        onChange={(valor) => onChange("descripcion", valor)}
      />
      {errores.descripcion && (
        <Alert severity="error" sx={{ marginTop: "15px" }}>
          {errores.descripcion}
        </Alert>
      )}
    </FormControl>
  </SeccionEvento>
);

export default NameSection;
